import AnalyticDevicesList from '../components/analytics/AnalyticDevicesList.js';
import { useIntl } from '../hooks';

export default function Analytics() {
  const intl = useIntl();

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold mb-6 text-gray-900">
        {intl.formatMessage({ id: 'analytics.title' })}
      </h1>
      <AnalyticDevicesList />
    </div>
  );
}
